import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  MaterialReactTable,
  useMaterialReactTable,
  createMRTColumnHelper,
  type MRT_ColumnDef,
} from 'material-react-table';

import {
  Box,
  Button,
  ListItemIcon,
  MenuItem,
  Typography,
  lighten,
} from '@mui/material';

// import { LoanAmortization } from '../../../interface/ILoanManagement';
import { ImportLog } from '../../../interface/IImport';

import helper from '../../../helpers/index';

import iconView from '../../../assets/visible.png';
import iconEdit from '../../../assets/edit-icon.png';
import iconDelete from '../../../assets/delete.png';



//example data type


const columnHelper = createMRTColumnHelper<ImportLog>();

interface ImportLogTableProps {
  data: ImportLog[];
  viewLog: (hangfireImportId: number, importLog: string) => Promise<void>;
}



const ImportLogTable: React.FC<ImportLogTableProps> = ({ data, viewLog }) => {


  //should be memoized or stable
  const columns = useMemo<MRT_ColumnDef<ImportLog>[]>(
    () => [
      {
        accessorKey: 'username',
        header: 'Username',
        enableSorting: true
      },
      //   {
      //     accessorFn: (row: ImportLog) => row.dueDate ? `${helper.formatLongDate(row.dueDate)}` : '',
      //     id: 'dueDate',
      //     header: 'Due Date',
      //     enableSorting: true
      //   },
      {
        accessorKey: 'importDate',
        header: 'Import Date'
      },
      {
        accessorKey: 'filename',
        header: 'File name',
        size: 200,
      },
      {
        accessorKey: 'dataType',
        header: 'Principal Repaid',
        size: 200,
      },
      {
        accessorKey: 'noEntries',
        header: 'No of Entries',
        size: 200,
      },
      {
        accessorKey: 'importStatus',
        header: 'Import Status',
        size: 200,
      },
      {
        header: 'Action',
        accessorFn: (row: ImportLog) => {
          // Initialize local state for each row's payment status

          return (
            <Box>
              <button className='btn-white-green-2'
                onClick={async () => {
                  await viewLog(row.hangfireImportId, row.importLog)
                }}
              >View Log</button>
            </Box>
          );
        }
      }
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    enableColumnActions: false,
    muiTablePaperProps: {
      elevation: 1,
      sx: {
        boxShadow: 'none',
        width: '100%',
        background: 'transparent',
        display: 'grid',

      }
    }
  });

  return <MaterialReactTable table={table} />;
};

export default ImportLogTable;
